/**
 * B1954 Buy 2 get 1 deal.
 *
 * Keeps the announcement bar countdown current and hides the deal banner and cart message once the end time
 * passes. The end time is one fixed Unix timestamp from theme settings, rendered into `data-b2g1-end`, so every
 * visitor counts down to the same moment. Nothing is stored per visitor and nothing restarts at zero.
 */

/**
 * @param {number} value
 * @returns {string}
 */
const pad = (value) => String(value).padStart(2, '0');

/**
 * Formats the time left, e.g. "12d 04h 31m". The final hour shows minutes and seconds.
 * @param {number} seconds - Whole seconds left, greater than zero.
 * @returns {string}
 */
function formatTimeLeft(seconds) {
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (days > 0) return `${days}d ${pad(hours)}h ${pad(minutes)}m`;
  if (hours > 0) return `${pad(hours)}h ${pad(minutes)}m`;

  return `${pad(minutes)}m ${pad(seconds % 60)}s`;
}

/**
 * Removes the deal slide and leaves the announcement bar on its normal messages.
 * @param {HTMLElement} slide
 */
function removeSlide(slide) {
  const bar = slide.closest('announcement-bar-component');
  slide.remove();

  if (!bar) return;

  const slides = bar.querySelectorAll('.announcement-bar__slide');

  slides.forEach((remaining, index) => remaining.setAttribute('aria-hidden', `${index !== 0}`));

  // The bar refreshes its slide list on the next DOM update, then restarts from the first message.
  requestAnimationFrame(() => {
    if ('current' in bar) bar.current = 0;
  });

  if (slides.length > 1) return;

  bar.removeAttribute('autoplay');
  bar.querySelector('slideshow-arrows')?.remove();
  if ('pause' in bar && typeof bar.pause === 'function') bar.pause();
}

function update() {
  const now = Date.now() / 1000;

  for (const element of document.querySelectorAll('[data-b2g1-end]')) {
    if (!(element instanceof HTMLElement)) continue;

    const end = Number(element.dataset.b2g1End);
    if (!Number.isFinite(end) || end <= 0) continue;

    const left = Math.floor(end - now);

    if (left <= 0) {
      if (element.hasAttribute('data-b2g1-slide')) {
        removeSlide(element);
      } else {
        element.hidden = true;
      }
      continue;
    }

    const countdown = element.querySelector('[data-b2g1-countdown]');
    if (!countdown) continue;

    const text = formatTimeLeft(left);
    if (countdown.textContent !== text) countdown.textContent = text;
  }
}

update();
setInterval(update, 1000);
